import { Navigation } from '@boozt/app/components/organisms';
import type { ReactNode } from 'react';

type PageProps = {
    children: ReactNode;
};

export default function SimpleLayout({ children }: PageProps) {
    return (
        <>
            <Navigation />
            <div className="page-container">
                {children}
            </div>
        </>
    );
}
